const placeListsLayout = {
  notificationTypes: {
    gameFavoriteNotifications: 'GameFavoriteNotifications',
    gameCloseNotifications: 'GameCloseNotifications'
  },
  sortsNeedRealtimeUpdate: {
    myFavorite: 'MyFavorite',
    myRecent: 'MyRecent'
  },
  pageTypes: {
    home: 'Home',
    gameDetail: 'GameDetail'
  },
  maxNumOfGamesPerList: 6,
  seeAllLinkLabel: 'Action.SeeAll',
  seeAllClass:
    'see-all-button games-filter-changer btn-min-width btn-secondary-xs btn-more see-all-link-icon',
  deviceTypes: {
    computer: 'Computer'
  }
};

export default placeListsLayout;
